export const enum ControllerAxis {
  LEFT_X = 0,
  LEFT_Y = 1,
  RIGHT_X = 2,
  RIGHT_Y = 3,
}

export const enum ControllerButton {
  A = 0,
  B = 1,
  X = 2,
  Y = 3,
  LB = 4,
  RB = 5,
  LT = 6,
  RT = 7,
  BACK = 8,
  START = 9,
  L3 = 10,
  R3 = 11,
  D_UP = 12,
  D_DOWN = 13,
  D_LEFT = 14,
  D_RIGHT = 15,
  SPECIAL = 16,
}
